import { Injectable } from '@angular/core';
import { GoogleTagManagerEventService } from '@edassist/common';

@Injectable({
	providedIn: 'root'
})
export class LiveChatMonitorService {
	private readonly CHAT_LAUNCHER_SELECTOR = '#cl-chat-launcher'; // Chat launcher selector
	private readonly CHAT_WIDGET_SELECTOR = '#cl-chat-widget'; // Chat container selector
	private readonly CLOSE_BUTTON_SELECTOR = '.cl-end-chat'; // Chat close button selector
	private readonly CHAT_CONFIRM_END_SELECTOR = '#cl-confirm-end'; // Parent container of the confirmation dialog
	private readonly CHAT_CONFIRM_BUTTON_SELECTOR = '#cl-confirm-end button.confirm'; // Specific "End Chat" button

	constructor(private readonly gtmEventService: GoogleTagManagerEventService) {}

	initializeChatListener() {
		this.setupMutationObserver();
		this.watchForConfirmDialog();
	}

	private setupMutationObserver() {
		const observer = new MutationObserver((mutations) => {
			for (const mutation of mutations) {
				for (const node of Array.from(mutation.addedNodes)) {
					if (node instanceof HTMLElement && node.matches(this.CHAT_WIDGET_SELECTOR)) {
						this.attachOpenListener(node);
						// Disconnect the observer after attaching the necessary listeners
						observer.disconnect();
						break;
					}
				}
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	}

	private attachOpenListener(launcher: HTMLElement) {
		launcher.addEventListener('click', (event) => {
			if ((event.target as HTMLElement)?.matches(this.CHAT_LAUNCHER_SELECTOR)) {
				this.gtmEventService.sendLiveChatInteract('open');
			}
		});
	}

	private watchForConfirmDialog() {
		const confirmObserver = new MutationObserver((mutations, observer) => {
			for (const mutation of mutations) {
				for (const node of Array.from(mutation.addedNodes)) {
					if (node instanceof HTMLElement && node.matches(this.CHAT_CONFIRM_END_SELECTOR)) {
						// Find the 'confirm' button within the newly added confirmation dialog
						const confirmButton = node.querySelector(this.CHAT_CONFIRM_BUTTON_SELECTOR);
						if (confirmButton) {
							confirmButton.addEventListener('click', () => {
								this.gtmEventService.sendLiveChatInteract('close');
							});
							// Disconnect the observer after attaching the listener to the close->confirm button
							observer.disconnect();
							break;
						}
					}
				}
			}
		});

		confirmObserver.observe(document.body, {
			childList: true,
			subtree: true
		});
	}
}
